<template>
  <button class="button" @click="$emit('switch')" :class="$attrs.class">
    <FiltersIcon />
    <p class="text">Filters</p>
  </button>
</template>

<script>
import FiltersIcon from "../../../public/img/icons/filters-icon.svg";

export default {
  name: "filters-switcher-btn",
  event: "switch",
  components: {
    FiltersIcon,
  },
};
</script>

<style lang="scss" scoped>
.button {
  outline: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.text {
  font-size: 16px;
  font-weight: 600;
}
</style>
